import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HYPERLIQUID_CHAIN_ID } from "../../../../anyspend/index.js";
/**
 * A generic warning text component with consistent styling.
 *
 * @example
 * <WarningText>
 *   Custom warning message
 * </WarningText>
 */
export function WarningText({ children, classes }) {
    return _jsx("p", { className: classes?.root || "anyspend-warning text-center text-xs italic text-red-500", children: children });
}
/**
 * A chain-aware warning text component that displays chain-specific warnings.
 * Returns null if there's no warning for the given chain.
 *
 * @example
 * <ChainWarningText chainId={HYPERLIQUID_CHAIN_ID} />
 *
 * @example
 * <ChainWarningText chainId={destinationChainId} classes={{ root: "my-custom-class" }} />
 */
export function ChainWarningText({ chainId, classes }) {
    // Chain-specific warning messages
    if (chainId === HYPERLIQUID_CHAIN_ID) {
        return (_jsxs(WarningText, { classes: classes, children: ["Minimum deposit amount: ", _jsx("b", { children: "$1" })] }));
    }
    // No warning for this chain
    return null;
}
